import { ErrorBoundary } from 'react-error-boundary';

import { cn } from 'lib/helpers/utility';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { IconSvg } from './lib/Icon.generated';

import './lib/Icon.scss';

/**
 * @param {import('./lib/propTypes').IconProps} props
 */

const Icon = ({
  icon,
  size,
  className,
  color,
  shade = color === 'neutral' ? 700 : 500,
  fill = true,
  stroke = false,
  onClick,
  disabled = false,
  focusable = false,
  customColor,
  disableColor = false,
  ...rest
}) => {
  const isInteractive = typeof onClick === 'function';
  const isFocusable = focusable && isInteractive;

  const handleClick = (e) => {
    if (disabled || !isInteractive) return;
    e.stopPropagation();
    onClick();
  };

  const handleKeyDown = (e) => {
    if (disabled || !isInteractive) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div
        onClick={(e) => handleClick(e)}
        onKeyDown={isFocusable ? handleKeyDown : undefined}
        role={isFocusable ? 'button' : undefined}
        tabIndex={isFocusable && !disabled ? 0 : undefined}
        aria-disabled={isFocusable && disabled ? true : undefined}
        style={{
          ...(size && { width: size, minWidth: size }),
          ...(customColor && (stroke ? { stroke: customColor } : { fill: customColor })),
          ...(!onClick && { cursor: 'inherit' })
        }}
        className={cn(
          'Icon',
          `Icon--${icon}`,
          size && 'Icon--size',
          onClick && 'cursor-pointer',
          disabled && 'cursor-not-allowed opacity-50',
          fill && !disableColor && 'change-fill-color',
          stroke ? 'change-stroke-color' : !disableColor && 'change-fill-color',
          customColor && `Icon-color--${customColor}`,
          customColor && (stroke ? 'custom-stroke-color' : 'custom-fill-color'),
          color === 'white' || color === 'black' ? `Icon--${color}` : `Icon--${color}-${shade}`,
          className
        )}
        {...rest}>
        {IconSvg[icon]}
      </div>
    </ErrorBoundary>
  );
};

export default Icon;
